import { render, staticRenderFns } from "./ReactivationCampaignGlance.vue?vue&type=template&id=65b7416c&"
import script from "./ReactivationCampaignGlance.vue?vue&type=script&lang=ts&"
export * from "./ReactivationCampaignGlance.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports